module.exports = __webpack_public_path__ + "img/parcoursPro.e5ab7b84.svg";